// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"a9836ed4","195":"4e5636ae","777":"8f1f1ec9"}[chunkId] + ".chunk.css";
};